import {
  Component,
  OnInit,
  OnDestroy,
  HostBinding,
  Optional,
} from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil, filter, delay } from 'rxjs/operators';

import { BroadcastService } from '../../services/broadcast.service';
import { EventBusService } from '../../services/event-bus.service';
import { AnnotationsV2Service } from '../../services/annotations-v2.service';

@Component({
  selector: 'viewer-fullscreen-loader',
  templateUrl: './fullscreen-loader.component.html',
  styleUrls: ['./fullscreen-loader.component.scss'],
})
export class FullscreenLoaderComponent implements OnInit, OnDestroy {
  @HostBinding('class.active') active = true;

  private unsubscribeBroadcast: Subject<void> = new Subject<void>();

  private _pageLoaded = false;
  private _groupMemosLoaded = false;

  constructor(
    private $: BroadcastService,
    private eventBus: EventBusService,
    @Optional() private _annotations: AnnotationsV2Service | null
  ) {}

  private _tryDeactivateLoader(): void {
    if (!this._pageLoaded) {
      return;
    }
    const groupId = this._annotations?.getState().groupId;
    if (groupId != null && !this._groupMemosLoaded) {
      return;
    }
    this.active = false;
  }

  ngOnInit(): void {
    merge(this.eventBus.on('ContentsComponent:itemLoad'))
      .pipe(takeUntil(this.unsubscribeBroadcast))
      .subscribe(() => {
        this._pageLoaded = true;
        this._tryDeactivateLoader();
      });

    this.eventBus
      .on('ReadingGroupMemoListComponent:initialLoadComplete')
      .pipe(takeUntil(this.unsubscribeBroadcast))
      .subscribe(() => {
        this._groupMemosLoaded = true;
        this._tryDeactivateLoader();
      });

    this.$.on<boolean>('window.resize.start')
      .pipe(
        takeUntil(this.unsubscribeBroadcast),
        filter((reload) => reload)
      )
      .subscribe(() => {
        this.active = true;
      });

    this.$.on('window.resize.finish')
      .pipe(takeUntil(this.unsubscribeBroadcast), delay(100))
      .subscribe((reload) => {
        if (!reload) {
          this.active = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeBroadcast.next();
    this.unsubscribeBroadcast.complete();
  }
}
